import React, { useEffect, useState } from 'react';
import { Referrer } from "../typings";
import { Row } from "../components/Flex";
import { toast } from "react-toastify";
import { useApi } from "../api-context";
import { fetchReferrers } from "./referral-api";
import ReferrerRow from "./ReferrerRow";

function ReferralsPage() {
    const api = useApi();
    const [referrers, setReferrers] = useState<Referrer[]>([]);

    const loadReferrers = () => {
        fetchReferrers(api)
            .then(res => {
                setReferrers(res);
            })
            .catch((reason) => {
                if (reason !== 'Unauthorized') {
                    toast.error('Failed to load federations');
                }
            });
    };

    useEffect(() => {
        loadReferrers();
    }, []);

    const renderColumnHeader = (title: string, prop: string, flex: number) => {
        return (
            <div style={{ flex, display: 'flex' }}>
                <div className="column-header">
                    <div>{title}</div>
                </div>
            </div>
        );
    };

    return (
        <div className="page-container drill-files-page">
            <Row gap={8} style={{marginBottom: '32px'}}>
                <div style={{ flex: 1 }} className="main-title">
                    Referrers
                </div>
            </Row>
            <Row style={{ padding: '12px 16px', marginBottom: '12px' }}>
                {renderColumnHeader('Email', 'email', 2)}
                {renderColumnHeader('Confirmed / Total', 'total', 1)}
                <div style={{ width: '28px' }}/>
            </Row>
            <div className="content-container" style={{ marginBottom: '32px', gap: '6px' }}>
                {referrers.map((referrer) => (
                    <ReferrerRow
                        key={referrer.id}
                        referrer={referrer}
                    />
                ))}
            </div>
        </div>
    );
}

export default ReferralsPage;
